/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Img from 'react-image';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import jump from 'jump.js';
import { Link } from '@reach/router';

import { FaLinkedin } from 'react-icons/fa';

import { history } from '../../utils/router-history';

import styles from './index.module.scss';
let cx = classNames.bind(styles);

const menu_list = [
	{ link: 'nosotros', name: 'layout.menu.who_we_are' },
	{ link: 'marcas', name: 'layout.menu.trademark' },
	{ link: 'areas', name: 'layout.menu.areas' },
	{ link: 'office_tour', name: 'layout.menu.office' },
	{ link: 'sustentabilidad', name: 'layout.menu.sustentabilidad' },
	{ link: 'testimonios', name: 'layout.menu.testimonials' },
	{ link: 'beneficios', name: 'layout.menu.benefits' },
];
// const menu_list = [];

const Footer = props => {
	const { t } = useTranslation();

	let navMenuClass = classNames({
		'cursor-pointer menu-items text-xs font-bold font-Avenir-Black inline-block no-underline py-2 px-2 font-medium text-white': true,
	});

	const navigateTo = section => {
		if (props.page && props.page === 'home') {
			jump(`section#${section}`, {
				offset: -90,
				duration: 1000,
			});
		} else {
			navigateToHome(section);
		}
	};

	const navigateToHome = section => {
		history.navigate('/#' + section, { replace: true });
	};

	return (
		<footer className={cx({ footer: true, 'bg-tcn-red text-white': true })}>
			<div className='container mx-auto py-10'>
				<div className='w-full flex flex-col lg:flex-row'>
					<div className='w-full lg:w-3/12 flex text-base flex-col items-center justify-center lg:justify-end'>
						<a
							className='text-orange-600 no-underline hover:no-underline font-bold text-2xl lg:text-4xl'
							href='/'
						>
							<Img
								className={cx({ logo: true })}
								src={`${process.env.REACT_APP_ASSET_URL}images/logo.png`}
								alt='Logo'
							/>
						</a>
					</div>
					<div className='flex flex-col lg:w-9/12'>
						<div className='w-full flex text-base flex-row items-center justify-end lg:justify-end'>
							<ul className='list-reset hidden lg:flex justify-end flex-1 items-center'>
								{menu_list.map(menu => (
									<li key={menu.link.toString()} className='mr-2 text-white'>
										<span
											className={navMenuClass}
											href='#'
											onClick={() => navigateTo(menu.link)}
										>
											<p className='text-white font-bold font-Avenir-Black'>{t(menu.name)}</p>
										</span>
									</li>
								))}
								<li className='mr-2'>
									<Link id='navAction' to='/ofertas' className={navMenuClass}>
										{t('layout.menu.opportunities')}
									</Link>
								</li>
							</ul>
						</div>
						<div className='w-full flex text-base flex-row items-end justify-center lg:justify-end'>
							<a
								href='https://www.linkedin.com/company/ideal-s.a./'
								target='_blank'
								className='flex flex-row font-bold text-white text-xl mt-4 font-bold font-Avenir-Black'
							>
								Síguenos en Linkedin{' '}
								<FaLinkedin className='mt-1 ml-2 text-2xl' />
							</a>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
